module.exports = __webpack_public_path__ + "img/digitalPowerPlantInspection.a73e0bb8.svg";